<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
            {{ $t('landlord.menu.settings') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div id="kt_content_container" class="container-fluid">
        <div class="row g-5 g-xl-8">
          <!-- Sidebar Menu -->
          <div class="col-xl-3">
            <div class="card card-flush h-100">
              <div class="card-header pt-5">
                <h3 class="card-title align-items-start flex-column">
                  <span class="card-label fw-bolder text-dark d-flex align-items-center">
                    <span class="bullet bullet-vertical h-20px bg-primary me-3"></span>
                    {{ $t('landlord.menu.settings') }}
                  </span>
                </h3>
              </div>
              <div class="card-body pt-5">
                <router-link
                  :to="{ name: 'landlord-settings-support' }"
                  class="setting-link"
                  :class="{ active: isActiveRoute(['landlord-settings-support']) }"
                >
                  <i class="bi bi-headset text-primary"></i>
                  <span>{{ $t('landlord.menu.settings_support') }}</span>
                  <i class="bi bi-chevron-right"></i>
                </router-link>
                <router-link
                  :to="{ name: 'landlord-settings-whatsapp' }"
                  class="setting-link"
                  :class="{ active: isActiveRoute(['landlord-settings-whatsapp']) }"
                >
                  <i class="bi bi-whatsapp text-success"></i>
                  <span>WhatsApp</span>
                  <i class="bi bi-chevron-right"></i>
                </router-link>
                <router-link
                  :to="{ name: 'landlord-settings-integrations' }"
                  class="setting-link"
                  :class="{ active: isActiveRoute(['landlord-settings-integrations']) }"
                >
                  <i class="bi bi-plug text-info"></i>
                  <span>Intégrations</span>
                  <i class="bi bi-chevron-right"></i>
                </router-link>
                <router-link
                  :to="{ name: 'landlord-settings-landing' }"
                  class="setting-link"
                  :class="{ active: isActiveRoute(['landlord-settings-landing']) }"
                >
                  <i class="bi bi-images text-warning"></i>
                  <span>Site vitrine</span>
                  <i class="bi bi-chevron-right"></i>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="col-xl-9">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()

const isActiveRoute = (routeNames) => {
  return routeNames.includes(route.name)
}
</script>

<style scoped>
.setting-link {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  border-bottom: 1px dashed #eee;
  text-decoration: none;
  transition: all 0.2s ease;
  border-radius: 6px;
  margin-bottom: 2px;
}

.setting-link:last-child {
  border-bottom: none;
}

.setting-link:hover {
  background-color: #f9f9f9;
  padding-left: 15px;
}

.setting-link:hover span {
  color: #0b3d87;
}

.setting-link.active {
  background-color: rgba(var(--kt-primary-rgb, 11, 61, 135), 0.08);
  border-color: transparent;
}

.setting-link.active span {
  color: #0b3d87;
  font-weight: 600;
}

.setting-link > i:first-child {
  font-size: 1.3rem;
  width: 32px;
  flex-shrink: 0;
}

.setting-link > span {
  flex: 1;
  font-weight: 500;
  color: #181c32;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}

.setting-link > i:last-child {
  font-size: 0.75rem;
  color: #b5b5c3;
}
</style>
